module.exports = __webpack_public_path__ + "media/images/pic/popup/popup-desktop-icons-b899e9f7ba63a40e7d0514b6738b5d55.png";